export const getFileExtension = (url) => {
  // Get the last part of the URL after the last '/'
  const filename = url.substring(url.lastIndexOf("/") + 1);

  // Get the file extension by getting the last part of the filename after the last '.'
  const extension = filename.substring(filename.lastIndexOf(".") + 1);

  return extension;
};

export const isObjectEmpty = (obj) => {
  for (const key in obj) {
    if (obj[key]) {
      if (obj[key] === '{"min":0,"max":20000000}') {
      } else {
        return false;
      }
    }
  }
  return true;
};

export const validEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const noStartSpace = (_, value) => {
  console.log("hit validator value::", value);

  if (!value) {
    return Promise.resolve();
  }

  const text = value.replace(/<[^>]+>/g, "");

  if (text.startsWith(" ")) {
    return Promise.reject(new Error("Should not contain space at start"));
  }

  return Promise.resolve();
};

export const noLeadingSpace = (_, value) => {
  console.log("hit here noLeadingSpace::", value);

  if (!value) {
    return Promise.resolve();
  }

  if (value.startsWith(" ")) {
    return Promise.reject(new Error("Should not contain space at start"));
  }

  if (value.endsWith(" ")) {
    return Promise.reject(new Error("Should not contain space at end"));
  }

  if (value.trim().length === 0) {
    return Promise.reject(new Error("Value cannot be only spaces"));
  }

  if (/\s{2,}/.test(value)) {
    return Promise.reject(
      new Error("Should not contain multiple consecutive spaces")
    );
  }

  return Promise.resolve();
};
